/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";
import AsyncSelect from "react-select/async";

import FormLabel from "./FormLabel";
import styled from "styled-components";
import FormRequiredText from "./FormRequiredText";


const AsyncSelectStyled = styled(AsyncSelect) `
  div {
    border-radius: 0;
  }
`;

const FormAsyncSelect = (props) => {
    const {
        label,
        loadOptions,
        isClearable,
        cacheOptions,
        defaultOptions,
        onChange,
        value,
        getOptionLabel,
        getOptionValue,
        onInputChange,
        isInvalid,
        placeholder,
        required,
        size
    } = props;

    const customStyles = {
        control: (styles) => ({ ...styles, borderColor: '#c13727 !important' }),
    }

    const smallStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: 'calc(1.5em + 0.5rem + 2px)',
            height: 'calc(1.5em + 0.5rem + 2px)',
            fontSize: '0.875rem',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: 'calc(1.5em + 0.5rem + 2px)',
            padding: '0.25rem 0.5rem',
        }),
        input: (provided) => ({
            ...provided,
            fontSize: '0.875rem',
            padding: '0',
            margin: '0',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: 'calc(1.5em + 0.5rem + 2px)',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0.25rem 0.5rem',
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: '0.25rem 0.5rem',
        }),
    }

    let finalStyles;
    if (size === 'sm') {
        finalStyles = {
            ...smallStyles,
            control: (styles) => ({
                ...smallStyles.control(styles),
                ...(isInvalid ? customStyles.control(styles) : {}),
            })
        };
    } else {
        finalStyles = isInvalid ? customStyles : undefined;
    }

    return (
        <>
            {label && (
                <FormLabel>
                    {label}
                    {required && (
                        <FormRequiredText> *</FormRequiredText>
                    )}
                </FormLabel>
            )}
            <AsyncSelectStyled
                isClearable={isClearable}
                cacheOptions={cacheOptions}
                defaultOptions={defaultOptions}
                loadOptions={loadOptions}
                getOptionLabel={e => getOptionLabel(e)}
                getOptionValue={e => getOptionValue(e)}
                onChange={onChange}
                onInputChange={onInputChange}
                styles={finalStyles}
                value={value}
                placeholder={placeholder}
            />
        </>
    );
}

export default FormAsyncSelect;
